module.exports = __webpack_public_path__ + "static/media/sponsorships-tracking.33aad415.png";